import WaitlistCta from './WaitlistCta';
import styles from './ClosingSection.module.css';

export default function ClosingSection({ onOpenWaitlist }) {
  return (
    <section className={styles.section}>
      <div className={styles.border}>
        <div className={styles.header}>
          <span className={styles.index}>[ 03 ]</span>
          <h2 className={styles.title}>Early Access</h2>
        </div>

        <div className={styles.body}>
          <p className={styles.statement}>
            The teams that adopt AI-native infrastructure first will define the
            next era of software delivery. The rest will spend years
            retrofitting tools that were never designed for this.
          </p>

          <p className={styles.emphasis}>
            We're building CMPND for the teams that refuse to wait.
          </p>

          <WaitlistCta onOpen={onOpenWaitlist} />
        </div>
      </div>
    </section>
  );
}
